import { Component } from '@angular/core';

@Component({
  selector: 'iam-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
